import React from 'react';
import { FiCalendar, FiShare2 } from 'react-icons/fi';
import LogoAlt from '../../../assets/logoAlt.svg';

const ContentImage = ({ src, alt = '' }) => (
  <figure className="blog-content-block blog-content-image">
    <img src={src} alt={alt} />
  </figure>
);

const BlogArticle = ({ post }) => {
  const handleShare = async () => {
    const shareData = {
      title: post.title,
      text: post.summary,
      url: window.location.href,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
        return;
      }
      await navigator.clipboard.writeText(window.location.href);
      alert('Link copied to clipboard');
    } catch (error) {
      // user cancelled share
    }
  };

  const renderBlocks = () => {
    if (post.bodyBlocks?.length) {
      return post.bodyBlocks.map((block, index) => {
        if (block.type === 'heading') {
          return <h2 key={`${post.id}-h-${index}`}>{block.text}</h2>;
        }
        if (block.type === 'image') {
          return (
            <ContentImage
              key={`${post.id}-i-${index}`}
              src={block.src || block.url || block.image}
              alt={block.alt || ''}
            />
          );
        }
        return (
          <p
            key={`${post.id}-p-${index}`}
            dangerouslySetInnerHTML={{ __html: block.html || block.text || '' }}
          />
        );
      });
    }

    if (post.contentHtml) {
      return (
        <div
          className="blog-rich-text"
          dangerouslySetInnerHTML={{ __html: post.contentHtml }}
        />
      );
    }

    return <p>No content available for this post.</p>;
  };

  return (
    <div className="blog-article">
      <header className="blog-article-header">
        <h1>{post.title}</h1>

        <div className="blog-article-meta-row">
          <div className="blog-article-meta">
            <span>
              <FiCalendar aria-hidden="true" />
              {post.date}
            </span>
            <span className="blog-article-category">
              <span className="category-dot" aria-hidden="true" />
              {post.category}
            </span>
          </div>
          {post.summary ? <p className="blog-article-summary">{post.summary}</p> : null}
        </div>

        <div className="blog-article-author-row">
          <div className="blog-article-author">
            <img src={LogoAlt} alt="" />
            <span>{post.author}</span>
          </div>
          <button type="button" className="blog-share-btn" onClick={handleShare}>
            <FiShare2 aria-hidden="true" />
            Share
          </button>
        </div>
      </header>

      {post.image ? (
        <div className="blog-article-hero">
          <img src={post.image} alt="" />
        </div>
      ) : null}

      <div className="blog-article-body-outer">
        <div className="blog-article-body">{renderBlocks()}</div>
      </div>
    </div>
  );
};

export default BlogArticle;
